import { SvgIcon, SvgIconProps } from '@mui/material'
const ChevronUpIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"> <path fillRule="evenodd" clipRule="evenodd" d="M10.5858 7.99985C11.3668 7.2188 12.6332 7.2188 13.4142 7.99985L18.7071 13.2927C19.0976 13.6833 19.0976 14.3164 18.7071 14.707C18.3166 15.0975 17.6834 15.0975 17.2929 14.707L12 9.41406L6.70711 14.707C6.31658 15.0975 5.68342 15.0975 5.29289 14.707C4.90237 14.3164 4.90237 13.6833 5.29289 13.2927L10.5858 7.99985Z" fill="#0E1426" />
      </svg>
    </SvgIcon>)
}
export default ChevronUpIcon